import React, { Component } from 'react';
import { connect } from 'react-redux';
import { obtemDadosBenchmarkUsuario } from '../../benchmark/redux/benchmarkOperations';
import {
  atualizaPermissoesUsuarioAuth0,
  obtemUsuarioAuth0,
} from '../redux/usuarioAuth0VinculoOperations';
import UsuarioAuth0VinculoTab from './usuarioAuth0VinculoTab';
export class UsuarioAuth0VinculoTabContainer extends Component {
  state = {
    chamadaUsuarioAuthConcluida: false,
  };


  async componentDidMount() {
    const { usuario } = this.props;
    this.props.obtemUsuarioAuth0(usuario.Email, usuario.IdUsuario);
    this.props.obtemDadosBenchmarkUsuario(usuario.IdUsuario);
    this.setState({
      chamadaUsuarioAuthConcluida: true,
    });
  }

  shouldComponentUpdate(nextProps, nextState) {
    return this.state.chamadaUsuarioAuthConcluida === true;
  }

  render() {
    const {
      usuario,
      usuarioAuth0,
      benchmarkData,
      atualizaPermissoesUsuarioAuth0
    } = this.props;

    return (
      <UsuarioAuth0VinculoTab
        usuario={usuario}
        usuarioAuth0={usuarioAuth0}
        benchmarkData={benchmarkData}
        chamadaUsuarioAuthConcluida={this.state.chamadaUsuarioAuthConcluida}
        atualizaPermissoesUsuarioAuth0={atualizaPermissoesUsuarioAuth0}
      />
    );
  }
}

const mapsDispatchToProps = {
  obtemUsuarioAuth0: obtemUsuarioAuth0,
  obtemDadosBenchmarkUsuario: obtemDadosBenchmarkUsuario,
  atualizaPermissoesUsuarioAuth0: atualizaPermissoesUsuarioAuth0,
};

export const mapStateToProps = (state) => {
  return {
    usuarioAuth0: state.usuarioAuth.usuarioAuth0,
    benchmarkData: state.benchmark,
  };
};

UsuarioAuth0VinculoTabContainer.defaultProps = {
  usuario: {},
  usuarioAuth0: {
    permissoes: {},
  },
  benchmarkData: {
    localUserStatus: null,
    associacoes: [],
    carregando: false,
  },
};
export default connect(
  mapStateToProps,
  mapsDispatchToProps
)(UsuarioAuth0VinculoTabContainer);
